import React from "react";

export default function TerminosYCondiciones() {
  return (
    <div style={{
      maxHeight: "200px",
      overflowY: "auto",
      padding: "15px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      backgroundColor: "#f9f9f9",
      fontSize: "12px",
      lineHeight: "1.5",
      color: "#333",
      marginBottom: "10px",
      textAlign: "justify"
    }}>
      <h4 style={{ marginTop: 0, textAlign: "center" }}>ACUERDO DE TÉRMINOS Y CONDICIONES DE USO Y TRATAMIENTO DE INFORMACIÓN</h4>
      <p style={{ textAlign: "center", fontWeight: "bold" }}>Plataforma referenciate.com</p>
      
      <p>Entre los usuarios de la plataforma referenciate.com (en adelante, el “USUARIO”) y la sociedad titular o administradora de la plataforma (en adelante, la “PLATAFORMA”), se celebra el presente Acuerdo de Términos y Condiciones, el cual tiene carácter jurídicamente vinculante, regido por las leyes de la República de Colombia, en especial la Ley 1581 de 2012, el Decreto 1377 de 2013, el Decreto 1074 de 2015, y demás normas concordantes en materia de protección de datos personales, Habeas Data y comercio electrónico.</p>
      <p>La aceptación electrónica de este documento constituye manifestación expresa, previa, informada e inequívoca de voluntad, con los mismos efectos jurídicos de una firma manuscrita, conforme a la Ley 527 de 1999.</p>

      <h5>CLÁUSULA PRIMERA – DEFINICIONES</h5>
      <p>Para efectos del presente acuerdo se entenderá por:</p>
      <ul>
        <li><strong>Datos personales:</strong> Cualquier información vinculada o que pueda asociarse a una persona natural o jurídica identificada o identificable.</li>
        <li><strong>Datos de terceros:</strong> Información de personas naturales o jurídicas distinta del USUARIO, ingresada, consultada o reportada dentro de la PLATAFORMA.</li>
        <li><strong>Consulta:</strong> Toda búsqueda, verificación, análisis o evaluación realizada dentro del sistema.</li>
        <li><strong>Reporte:</strong> Resultado consolidado generado por la PLATAFORMA con base en datos propios, de terceros o fuentes externas.</li>
        <li><strong>Titular:</strong> Persona natural o jurídica cuyos datos son objeto de tratamiento.</li>
      </ul>

      <h5>CLÁUSULA SEGUNDA – AUTORIZACIÓN EXPRESA DE HABEAS DATA</h5>
      <p>El USUARIO autoriza de manera previa, expresa, informada, voluntaria e inequívoca a la PLATAFORMA para realizar el tratamiento de sus datos personales, lo cual incluye, pero no se limita a:</p>
      <ul>
        <li>Recolección, almacenamiento, uso, circulación, actualización, rectificación, transmisión y supresión de datos personales.</li>
        <li>Consulta en bases de datos públicas o privadas, centrales de riesgo, operadores de información, listas restrictivas o fuentes legítimas de información.</li>
        <li>Conservación de historiales de consultas, reportes y actividades dentro de la PLATAFORMA.</li>
      </ul>
      <p>El USUARIO declara conocer que tiene derecho a:</p>
      <ul>
        <li>Conocer, actualizar y rectificar sus datos.</li>
        <li>Solicitar prueba de la autorización otorgada.</li>
        <li>Ser informado sobre el uso de sus datos.</li>
        <li>Revocar la autorización y/o solicitar la supresión de sus datos, cuando no exista obligación legal o contractual de permanencia.</li>
      </ul>

      <h5>CLÁUSULA TERCERA – TRATAMIENTO DE DATOS DE TERCEROS</h5>
      <p>El USUARIO declara y garantiza de manera expresa que:</p>
      <ul>
        <li>Toda información de terceros ingresada a la PLATAFORMA ha sido obtenida de forma lícita y legítima.</li>
        <li>Cuenta con la autorización previa, expresa e informada del titular de los datos, cuando dicha autorización sea exigida por la normativa vigente.</li>
        <li>Asume plena responsabilidad civil, administrativa y penal por cualquier infracción derivada del ingreso, uso o divulgación indebida de datos de terceros.</li>
        <li>Mantendrá indemne a la PLATAFORMA frente a cualquier reclamación, demanda, investigación o sanción derivada del uso indebido de información de terceros.</li>
      </ul>
      <p>La PLATAFORMA actúa como responsable o encargada del tratamiento según el caso operativo, sin asumir responsabilidad por la veracidad originaria de los datos suministrados por los USUARIOS o terceros.</p>

      <h5>CLÁUSULA CUARTA – NATURALEZA DE LAS CONSULTAS, REPORTES Y EVALUACIONES</h5>
      <p>El USUARIO reconoce y acepta expresamente que:</p>
      <ul>
        <li>Las consultas, evaluaciones, análisis y reportes generados por la PLATAFORMA tienen naturaleza referencial, informativa y de apoyo a la toma de decisiones.</li>
        <li>Dichos resultados no constituyen certificación oficial, garantía de conducta futura, ni recomendación vinculante.</li>
        <li>La PLATAFORMA no asegura la exactitud absoluta, integridad o actualización permanente de la información, especialmente cuando proviene de terceros o fuentes externas.</li>
      </ul>
      <p>En consecuencia, toda decisión adoptada con base en la información obtenida será responsabilidad exclusiva del USUARIO.</p>

      <h5>CLÁUSULA QUINTA – RESPONSABILIDAD CONTRACTUAL</h5>
      <p>El USUARIO acepta que:</p>
      <ul>
        <li>Es el único responsable del uso que haga de la PLATAFORMA y de las decisiones basadas en sus resultados.</li>
        <li>Asume responsabilidad integral por los contratos, vínculos comerciales, laborales o financieros celebrados con base en la información obtenida.</li>
        <li>Exonera a la PLATAFORMA de cualquier responsabilidad por daños directos, indirectos, incidentales, consecuenciales o lucro cesante derivados del uso del servicio.</li>
        <li>La PLATAFORMA no será responsable por interrupciones, errores, omisiones o fallas técnicas.</li>
      </ul>

      <h5>CLÁUSULA SEXTA – INDEMNIDAD</h5>
      <p>El USUARIO se obliga a mantener indemne, defender y eximir de responsabilidad a la PLATAFORMA, sus representantes, socios, empleados y proveedores, frente a cualquier reclamación, sanción, pérdida o daño derivado de:</p>
      <ul>
        <li>Uso indebido de la información.</li>
        <li>Violación de derechos de terceros.</li>
        <li>Infracción de normas de Habeas Data.</li>
        <li>Uso fraudulento o no autorizado de la PLATAFORMA.</li>
      </ul>

      <h5>CLÁUSULA SÉPTIMA – ACEPTACIÓN ELECTRÓNICA</h5>
      <p>El USUARIO reconoce que la aceptación mediante clic, registro o uso de la PLATAFORMA constituye:</p>
      <ul>
        <li>Consentimiento expreso y vinculante.</li>
        <li>Manifestación de voluntad equivalente a firma electrónica conforme a la Ley 527 de 1999.</li>
        <li>Aceptación total de las condiciones aquí establecidas sin reserva alguna.</li>
      </ul>

      <h5>CLÁUSULA OCTAVA – LEY APLICABLE Y JURISDICCIÓN</h5>
      <p>Este acuerdo se regirá por las leyes de la República de Colombia. Cualquier controversia será sometida a la jurisdicción de los jueces de la República de Colombia, sin perjuicio de mecanismos alternativos de solución de conflictos.</p>

      <h5>ACEPTACIÓN FINAL</h5>
      <p>Al aceptar estos términos, el USUARIO declara haber leído, comprendido y aceptado íntegramente este acuerdo, obligándose a su cumplimiento total.</p>
    </div>
  );
}
